//------------ REACT IMPORT --------------//
import React, { useState } from "react";
//--------- BOOTSTRAP ITEMS IMPORT ----------//
import { Button, Card, Image } from "react-bootstrap";
//------------ IMAGES IMPORT ---------------//
import { Delete, Eye, PdfImg } from "../../../../assets/images";
import AddReportModal from "../../Modals/AddReportModal";
import PaginationComponent from "../../CommanComponents/Pagination";
import AddMedicineModal from "../../Modals/AddMedicineModal";

const Reports = () => {
    const [showReportModal, setShowReportModal] = useState(false);
    return (
        <>
            <div className="task_tab_screen">
                <Card>
                    <Card.Body>
                        <Card>
                            <Card.Body>
                                <div className="card_details">
                                    <div className="left_area">
                                        <div className="img_one">
                                            <Image src={PdfImg} alt="..." />
                                        </div>
                                        <div className="text_area">
                                            <h5>Blood Test</h5>
                                            <p>Lorem ipsum dolor amet neque non</p>
                                        </div>
                                    </div>
                                    <div className="right_area">
                                        <div className="icons">
                                            <Image src={Eye} alt="..." />
                                            <Image src={Delete} alt="..." />
                                        </div>
                                    </div>
                                </div>
                                <div className="report_details">
                                    <div className="report_updated_by">
                                        <p>Updated by: Jospeh Jones</p>
                                        <p>5 july, 2023 11:00AM</p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                        <Button type="button" className="btn btn-primary" onClick={() => setShowReportModal(true)}>Add Reports</Button>
                    </Card.Body>
                </Card>
                {
                    showReportModal ? (
                        // <AddReportModal show={showReportModal} close={() => setShowReportModal(false)} />
                        <AddMedicineModal show={showReportModal} close={() => setShowReportModal(false)} />
                    ) : null
                }
            </div>
            <PaginationComponent />
        </>
    )
}

export default Reports;